
const removePunctuation = (str) => {
  str = str.replace('.', '');
  str = str.replace('.', '');
  str = str.replace('.', '');
  str = str.replace('-', '');
  str = str.replace('/', '');
  return str;
};

const normalizarDocumento = str => removePunctuation(str).toUpperCase();

const validarCnpjAlfanumerico = str => /^[A-Z0-9]{12}\d{2}$/.test(str) && str !== '00000000000000';

// retirado de http://www.receita.fazenda.gov.br/aplicacoes/atcta/cpf/funcoes.js
const validarCpf = (str) => {
  /* eslint-disable */
  let Soma;
  let Resto;
  Soma = 0;
  if (str == "00000000000") return false;

  for (let i=1; i<=9; i++) Soma = Soma + parseInt(str.substring(i-1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if ((Resto == 10) || (Resto == 11))  Resto = 0;
  if (Resto != parseInt(str.substring(9, 10)) ) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(str.substring(i-1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if ((Resto == 10) || (Resto == 11))  Resto = 0;
  if (Resto != parseInt(str.substring(10, 11) ) ) return false;
  return true;
  /* eslint-enable */
};

// retirado de http://www.geradorcnpj.com/javascript-validar-cnpj.htm
const validarCnpj = (str) => {
  /* eslint-disable */
  var cnpj = str;
  var numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais;
  digitos_iguais = 1;
  if (cnpj.length < 14 && cnpj.length < 15)
    return false;
  for (i = 0; i < cnpj.length - 1; i++)
    if (cnpj.charAt(i) != cnpj.charAt(i + 1))
    {
      digitos_iguais = 0;
      break;
    }
  if (!digitos_iguais)
  {
    tamanho = cnpj.length - 2
    numeros = cnpj.substring(0,tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--)
    {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
      return false;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--)
    {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
      return false;
    return true;
  }
  else
    return false;
  /* eslint-enable */
};


export const cnpjNumber = {
  getMessage() { // will be added to default English messages.
    return 'CNPJ inválido';
  },
  validate(str) {
    str = normalizarDocumento(str);
    if (str.length !== 14) {
      return false;
    }
    if (/^\d{14}$/.test(str)) {
      return validarCnpj(str);
    }
    return validarCnpjAlfanumerico(str);
  },
};

export const cpfNumber = {
  getMessage() { // will be added to default English messages.
    return 'CPF inválido';
  },
  validate(str) {
    str = removePunctuation(str);
    return validarCpf(str);
  },
};
/* eslint-disable */

export const cpfCnpjNumber = {
  getMessage() { // will be added to default English messages.
    return 'Documento inválido';
  },
  validate(str) {
    const third = str.length >= 4 ? str.slice(3, 4) : ".";
    str = normalizarDocumento(str);
    if (str.length <= 11 && third === ".") {
      return validarCpf(str);
    }
    if (/^\d{14}$/.test(str)) {
      return validarCnpj(str);
    }
    return validarCnpjAlfanumerico(str);
  },
};



// WEBPACK FOOTER //
// ./src/common/validations/social.js